import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { activeNetworkSelector, userSelector } from '../../redux/selectors';

export const useCommandBar = () => {
  const routerHistory = useHistory();
  const activeNetwork = useSelector(activeNetworkSelector);
  const user = useSelector(userSelector);
  const { pathname } = useLocation();

  const routerFunc = (newUrl) => routerHistory.push(newUrl);

  useEffect(() => {
    window.CommandBar?.boot();
    window.CommandBar?.addRouter(routerFunc);

    return () => {
      window.CommandBar?.shutdown();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (user.id) {
      window.CommandBar?.boot(`${user.id}`);
    }
  }, [user.id]);

  useEffect(() => {
    if (activeNetwork && pathname.startsWith(`/networks/${activeNetwork.slug}`)) {
      window.CommandBar?.addMetadata('currentNetworkSlug', activeNetwork.slug);
      window.CommandBar?.addMetadata('currentNetworkName', activeNetwork.name);
      window.CommandBar?.addMetadata('hasMatches', activeNetwork.isManager);
    }
  }, [activeNetwork, pathname]);
};
